export default {
    API_ENDPOINT: 'https://enigmatic-eyrie-84648.herokuapp.com/api',
    
    API_KEY: process.env.REACT_APP_API_KEY,
}